import React from 'react';

const SubmitHero = ({ title, description }) => (
  <section className="submit-hero">
    <h1 className="submit-hero-title">{title}</h1>
    <p className="submit-hero-description">{description}</p>
  </section>
);

export default SubmitHero;
